import React, { useState, useEffect } from 'react';

const ChangePasswordModal = ({ isOpen, user, onClose, onSubmit }) => {
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setPw(''); setConfirm(''); setError('');
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pw.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (pw !== confirm) { setError('Passwords do not match.'); return; }
    onSubmit(pw);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">Change Password</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl font-bold">×</button>
        </div>
        <div className="p-6">
          {user && <p className="text-sm text-gray-500 mb-4">Setting new password for <span className="font-semibold text-gray-700">{user.name}</span></p>}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">New Password</label>
              <input
                required type="password"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                value={pw} onChange={e => { setPw(e.target.value); setError(''); }}
                placeholder="Min. 6 characters"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Confirm Password</label>
              <input
                required type="password"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                value={confirm} onChange={e => { setConfirm(e.target.value); setError(''); }}
                placeholder="Repeat password"
              />
            </div>
            {error && <p className="text-xs text-red-500 font-medium">{error}</p>}
            <div className="pt-2 flex justify-end gap-3">
              <button type="button" onClick={onClose} className="px-5 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 text-sm">Cancel</button>
              <button type="submit" className="px-5 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 font-medium text-sm">Update Password</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;